





































































































































































































































































































































import { ACTIONS } from "@/consts";
import Vue from "vue";
import { mapState } from "vuex";
import { formatCurrency } from "../../../src/utils";
import { get, put } from "@/api";

export default Vue.extend({
  components: {},
  data(): { [key: string]: any } {
    return {
      isModalOpen: false,
      file: null,
      markedDeposited: false,
      showUploadModal: false,
      fileProgresses: {},
      statusTextMapping: {
        PENDING: "RAISED",
        RAISED: "RAISED",
        COLLECTED: "COLLECTED",
        DEPOSITED: "DEPOSITED",
        APPROVED: "APPROVED",
        REJECT: "REJECTED",
      },
    };
  },
  props: {
    column: {},
    row: {},
    hover: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState("uiModule", {
      isOnMobileDevice: "isOnMobileDevice",
    }),
  },
  inject: ["actionHandler"],
  methods: {
    async downloadCashDocument(id: any) {
      const resp: any = await get({
        endpoint: "gringotts.api.v1.attachment.presignedDownloadUrl",
        id,
      });
      if (resp.status.statusType == "SUCCESS") {
        const link = document.createElement("a");
        link.href = resp.attachmentModelList[0].preSignedDownloadUrl;
        link.download = "cash document";
        document.body.appendChild(link);
        link.target = "_blank";
        link.click();
        document.body.removeChild(link);
      } else {
        (this as any).$store.dispatch("uiModule/addToast", {
            severity: "error",
            message: "Failed to Download deposit slip",
          });
      }
    },
    formatCurrency,
    async handleDownloadDocument(file_id: any) {
      if (file_id) {
        try {
          const response: any = await put({
            endpoint: "sales.storage.api.v2.files.actions",
            body: {
              file_id: file_id,
            },
          });
          if (!response.error) {
            const link = document.createElement("a");
            link.href = response.response.url;
            let fineNameExtension =
              response.response?.url
                ?.split("?")[0]
                ?.split("/")
                ?.pop()
                ?.split(".")
                ?.pop() || "png";
            link.download = `Check Copy ${new Date().getTime()}.${fineNameExtension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } catch (error) {
          // TODO
          /** Handle this */
          /** Show message to user if it is required */
          // console.error('Error downloading file:', error);
        }
      }
    },
    handleRowItemClick(event: Event) {
      (this as any).actionHandler("rowselect", (this as any).row);
    },

    mappedStatus(status: string) {
      return this.statusTextMapping[status] || status;
    },
    getStatusTagColor(status: any) {
      switch (status) {
        case "RAISED":
          return "warning";
        case "PENDING":
          return "warning";
        case "COLLECTED":
          return "info";
        case "DEPOSITED":
          return "success";
        case "APPROVED":
          return "success";
        case "REJECTED":
          return "error";
        default:
          return "default";
      }
    },
    openFileUpload: function() {
      this.showUploadModal = !this.showUploadModal;
    },

    handleFileUpload(eventData: { file: { name: string | number } }) {
      this.$set(this.fileProgresses, eventData.file.name, -1);
      setTimeout(() => {
        this.$set(this.fileProgresses, eventData.file.name, -2);
      }, 2000);
    },
    handleClick(action: string) {
      if (action === "reject") {
        this.isModalOpen = true;
        (this as any).actionHandler("reject", (this as any).row);
      } else if (action === ACTIONS.deposited) {
        this.isModalOpen = true;
        (this as any).actionHandler("markAsDeposited", (this as any).row);
      } else if (action == ACTIONS.collected) {
        (this as any).actionHandler("markAsCollected", (this as any).row);
      }
    },
    closeModal() {
      this.isModalOpen = false;
      this.file = null;
    },
    markDeposited() {
      if (this.file) {
        this.markedDeposited = true;
        this.isModalOpen = false;
      }
    },
  },
});
